<form
    class="form-horizontal identity-id-proofing"
    role="form"
    novalidate
    (ngSubmit)="acceptTermsAndConditions()">
    <kno2-dialog-body>
        <div class="form-group row">
            <div class="col-sm-12">
                <label>
                    <input
                        type="checkbox"
                        name="agree"
                        [ngModel]="acceptedTerms()"
                        (ngModelChange)="acceptedTerms.set($event)" />
                    I have agreed to the terms and conditions provided by {{ userProfile()?.resellerName }}.
                </label>
            </div>
        </div>
    </kno2-dialog-body>

    <kno2-dialog-footer>
        <button
            id="accept"
            type="submit"
            class="btn btn-primary"
            [disabled]="!acceptedTerms()">
            @if (!userProfile()?.orgIsIdProofed) {
                <span>Next</span>
            } @else {
                <span>Close</span>
            }
        </button>
    </kno2-dialog-footer>
</form>
